import { useSrpContext } from '@/src/contexts'
import { useMessages, useTranslations } from 'next-intl'

import FareHighlights from './fareHighlights'

const EN_MONTHS = ['january','february','march','april','may','june','july','august','september','october','november','december']
const EN_DAYS = ['monday','tuesday','wednesday','thursday','friday','saturday','sunday']

function buildLookupMap (messages: Record<string, unknown>, section: string, keys: string[]): Record<string, string> {
    const data = (messages.form as Record<string, unknown>)?.[section] as Record<string, string> | undefined
    if (!data) return {}
    const map: Record<string, string> = {}
    for (const key of keys) {
        if (data[key]) map[key] = data[key]
    }
    return map
}

function translate (value: string, map: Record<string, string>): string {
    return map[value.toLowerCase()] ?? value
}

const FareHighlightsWrapper = () => {
    const {
        SEOSrpData: { sections }
    } = useSrpContext()
    const t = useTranslations('common.routeSeoContent')
    const messages = useMessages()
    const monthMap = buildLookupMap(messages as Record<string, unknown>, 'months', EN_MONTHS)
    const dayMap = buildLookupMap(messages as Record<string, unknown>, 'days', EN_DAYS)

    const fareSummary = sections?.whenToBook?.fareSummary
    const heroStats = sections?.hero?.stats
    if (!fareSummary?.available && !heroStats) return null

    const stats = []

    if (fareSummary?.cheapestMonth) {
        stats.push({ label: t('cheapestMonth'), value: translate(fareSummary.cheapestMonth, monthMap) })
    }
    if (fareSummary?.cheapestDay) {
        stats.push({ label: t('cheapestDay'), value: translate(fareSummary.cheapestDay, dayMap) })
    }
    if (fareSummary?.minFare) {
        stats.push({ label: t('startingFrom'), value: `${fareSummary.minFare} ${fareSummary.currency}` })
    }
    if (fareSummary?.maxFare) {
        stats.push({ label: t('upTo'), value: `${fareSummary.maxFare} ${fareSummary.currency}` })
    }
    if (heroStats?.lowestFareAirline) {
        stats.push({ label: t('cheapestAirline'), value: heroStats.lowestFareAirline })
    }
    if (heroStats?.weeklyFlights) {
        stats.push({ label: t('weeklyFlights'), value: String(heroStats.weeklyFlights) })
    }
    if (heroStats?.flightDuration) {
        stats.push({ label: t('flightDuration'), value: heroStats.flightDuration })
    }
    if (heroStats?.topAirlineNames?.length) {
        stats.push({ label: t('airlinesOnRoute'), value: String(heroStats.topAirlineNames.length) })
    }

    if (stats.length === 0) return null

    return <FareHighlights stats={stats} />
}

export default FareHighlightsWrapper
